import React, { Component } from "react";
import Slider from "react-slick";
import SliderSlide from "./SliderSlide";
import CarAnimation from "./CarAnimation";
import vwdata from "../scripts/analytics";
import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class SimpleSlider extends Component {
  componentDidMount(){
    let slickDots = document.getElementsByClassName('slick-dots')[0];
    slickDots.classList.add('slick-dots-down');
    let slickListDiv = document.getElementsByClassName('slick-list')[0]
    slickListDiv.addEventListener('wheel', event => {
      //event.preventDefault()
      if(event.deltaY > 10){
        this.slider.slickNext();
      }else if(event.deltaY < -10){
        this.slider.slickPrev();
      }
    });
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
      ScrollTrigger.create({
        trigger: ".slide1",
        start: "top top",
        end: "bottom top",
        ease: "none",
        onEnterBack: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,79);
            setTimeout(() => { window.scrollTo(0, 79); }, 100);
            this.slider.slickPrev();
            setTimeout(() => { justMoved = false; }, 200);
          }

        },
        onLeave: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,80);
            setTimeout(() => { window.scrollTo(0, 80); }, 100);
            this.slider.slickNext();
            setTimeout(() => { justMoved = false; }, 200);
          }
        },
        //markers: true,
      });
  
      var justMoved = false;

      ScrollTrigger.create({
        trigger: ".slide2",
        start: "top top",
        end: "bottom top",
        ease: "none",
        onEnterBack: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,159);
            setTimeout(() => { window.scrollTo(0, 159); }, 100);
            this.slider.slickPrev();
            setTimeout(() => { justMoved = false; }, 200);
          }

        },
        onLeave: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,160);
            setTimeout(() => { window.scrollTo(0, 160); }, 100);
            this.slider.slickNext();
            setTimeout(() => { justMoved = false; }, 200);
          }
        },
        //markers: true,
      });
      ScrollTrigger.create({
        trigger: ".slide3",
        start: "top top",
        end: "bottom top",
        ease: "none",
        onEnterBack: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,239);
            setTimeout(() => { window.scrollTo(0, 239); }, 100);
            this.slider.slickPrev();
            setTimeout(() => { justMoved = false; }, 200);
          }
        },
        onLeave: () => {
          
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,240);
            setTimeout(() => { window.scrollTo(0, 240); }, 100);
            this.slider.slickNext();
            setTimeout(() => { justMoved = false; }, 200);
          }
        },
        //markers: true,
      });
      ScrollTrigger.create({
        trigger: ".slide4",
        start: "top top",
        end: "bottom top",
        ease: "none",
        onEnterBack: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,319);
            setTimeout(() => { window.scrollTo(0, 319); }, 100);
            this.slider.slickPrev();
            setTimeout(() => { justMoved = false; }, 200);
          }
        },
        onLeave: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,320);
            setTimeout(() => { window.scrollTo(0, 320); }, 100);
            this.slider.slickNext();
            setTimeout(() => { justMoved = false; }, 200);
          }
        },
        //markers: true,
      });
      ScrollTrigger.create({
        trigger: ".slide5",
        start: "top top",
        end: "bottom top",
        ease: "none",
        onEnterBack: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,399);
            setTimeout(() => { window.scrollTo(0, 399); }, 100);
            this.slider.slickPrev();
            setTimeout(() => { justMoved = false; }, 200);
          }

        },
        onLeave: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,400);
            setTimeout(() => { window.scrollTo(0, 400); }, 100);
            this.slider.slickNext();
            setTimeout(() => { justMoved = false; }, 200);
          }
        },
        //markers: true,
      });
      ScrollTrigger.create({
        trigger: ".slide6",
        start: "top top",
        end: "bottom top",
        ease: "none",
        onLeaveBack: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,479);
            setTimeout(() => { window.scrollTo(0, 479); }, 100);
            this.slider.slickPrev();
            setTimeout(() => { justMoved = false; }, 200);
          }

        },
        onEnterBack: () => {
          if(justMoved == false){ 
            justMoved = true;
            window.scrollTo(0,480);
            setTimeout(() => { window.scrollTo(0, 480); }, 100);
            this.slider.slickNext();
            setTimeout(() => { justMoved = false; }, 200);
          }
        },
        //markers: true,
      });
  }
    


    
    let vh = window.innerHeight * 0.01;
    
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    var allFrames = gsap.utils.toArray(".carAnimationFrame");
    var allFramesButFirst = allFrames.slice(1,allFrames.length);
    var allFramesNotLast = allFrames.slice(0,-1);
    var next = 1;

    var action = gsap.timeline({defaults:{ease:'none', stagger:next}})

    .from(allFramesButFirst, {autoAlpha: 0})
    .to(allFramesNotLast, {autoAlpha:0}, next) 

    ScrollTrigger.create({
      trigger: ".box",
      scrub: true,
      animation: action,
      start: "top top",
      end: "bottom top",
      ease: "none",
      
    });
  }

  

  render() {
    
    var frMode = this.props.frMode;
    let darkClass;
    let carAnimation;
    var darkMode = window.sessionStorage.getItem("darkMode");

    //Analytics variables
    var lang;
    var side;
    var slide;
    
    

    if(frMode){
      lang = "French";
    }else{
      lang = "English";
    }

    if(darkMode == "true"){
      darkClass="darkSlider";
      side = "Side B - Dark";
      carAnimation = <CarAnimation darkMode='true'></CarAnimation>; 
    }else{
      darkClass="lightSlider";
      side = "Side A - Light";
      carAnimation = <CarAnimation darkMode='false'></CarAnimation>; 
    }
    // var vwdata = window.vwdata = window.vwdata || [];
    vwdata.push({
      eventInfo: {
        eventAction: "VWBasic_Pageload",
        pageName: "Car Cover",
        pageCategory: side,
      },
      environment: {
        language: lang,
      },
      user: {
        browserResolutionHeight: window.innerHeight.toString(),
        browserResolutionWidth: window.innerWidth.toString(),
      }
    });

    const settings = {
      dots: true,
      fade: true,
      lazyload: "progressive",
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: true,
       beforeChange: (currentSlide, nextSlide)=>{
        
        if(nextSlide == 0 || nextSlide == 1){
          $(".carAnimationContainer").show();
          $(".slick-slider").removeClass("backgroundFill");
        }else{
          $(".carAnimationContainer").hide();
          $(".slick-slider").addClass("backgroundFill");
        }

        var bodyEl = document.getElementsByTagName("body");

        if(nextSlide == 1 && currentSlide != 0){
          if(!(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent))) {
            window.scrollTo(0,80);
          }
        }

        let slickDots = document.getElementsByClassName('slick-dots')[0];
        if(nextSlide == 5){
          slickDots.classList.remove('slick-dots-down');
        }else{
          slickDots.classList.add('slick-dots-down');
        }

        slide = (nextSlide+1).toString();
        

        vwdata.push({
          eventInfo: {
            eventAction: "VWBasic_ContentSection_EnterViewport",
            pageName: "Car Cover",
            pageCategory: side,
            sectionName: slide,
          },
          environment: {
            language: lang,
          },
          user: {
            browserResolutionHeight: window.innerHeight.toString(),
            browserResolutionWidth: window.innerWidth.toString(),
          }
        });
        

       },
      afterChange: ()=>{
        
      }
      
    };

    //animated text will only appear at the end of the string
    //if you want it somewhere else you'll need to add the span yourself

    if(frMode){
      if(darkClass == "darkSlider"){
        return(
          <div className={darkClass}>
            <div className="box"></div>
            <div className="slideChangeContainer">
              <div className="slideChange slide1"></div>
              <div className="slideChange slide2"></div>
              <div className="slideChange slide3"></div>
              <div className="slideChange slide4"></div>
              <div className="slideChange slide5"></div>
              <div className="slideChange slide6"></div>
            </div>
          {carAnimation}
          <Slider {...settings} ref={slider => this.slider = slider && slider['innerSlider']}>
          
          <SliderSlide
          header="La plupart des<br/>housses de véhicule<br/>repoussent<br/>les éléments."
          headerBorder={false}
          animatedCaptionText="<p>La housse de véhicule la plus durable</p>"
          captionBorder={false}
          animatedBackground={true}
          cta={false}
          backgroundImg="/carcover/images/background/dark-sequence/frame_01.jpg"
          />
          <SliderSlide
          header="Celle-ci ne<br/>fait pas exception."
          headerBorder={false}
          animatedCaptionText="<p>La housse de véhicule la plus durable</p>"
          captionBorder={false}
          animatedBackground={true}
          cta={false}
          backgroundImg="/carcover/images/background/dark-sequence/frame_20.jpg"
          />
          <SliderSlide
          header="Depuis qu’on a terminé la conception de l’ID.4, "
          animatedHeaderText="on ne peut pas s’arrêter de l’admirer."
          headerBorder={true}
          caption="<p>Des lignes sophistiquées. Une silhouette distinctive et frappante. Et, bien sûr, son éclat tout droit sorti de la chaîne de montage. On savait qu’on devait faire tout ce qu’on pouvait pour que notre VUS 100 % électrique garde son aspect brillant et flambant neuf.</p><p>Donc, après plusieurs années de travail, on s’est à nouveau retroussé les manches pour concevoir le compagnon parfait de l’ID.4. Et le voici.</p>"
          
          captionBorder={true}
          cta={false}
          />
          
          <SliderSlide
          header="Vous l’avez deviné :<br/>"
          animatedHeaderText="c’est une house."
          headerBorder={true}
          caption="<p>Une housse de véhicule qui protégera votre ID.4 de tout ce que vous pouvez imaginer. C’est drôle de voir que quelque chose d’aussi classique qu’une housse de véhicule puisse s’adapter aux innovations de demain d’une aussi belle manière.</p>"
          
          captionBorder={true}
          cta={false}
          />

          <SliderSlide
          header="Alors, comment ça fonctionne<span class='fakeSpace--h1'>?</span>"
          headerBorder={true}
          caption="<p>C’est simple. On a conçu votre housse de véhicule avec une doublure protectrice qui repousse tout ce qui oserait salir votre magnifique ID.4. De la saleté et la poussière sur votre véhicule fraîchement lavé ? Non merci.</p><p>Des feuilles mortes sous vos essuie-glaces ? Pas question. Et les fientes d’oiseaux ? Ça, n’y pensez même pas. Tous ces éléments indésirables sont maintenant choses du passé grâce à cette toile de tissu sans pareille.</p>"
          
          captionBorder={true}
          cta={false}
          />
          <SliderSlide
          header="Dites <span class='animatedHeader' style='animation-delay:1s'>adieu</span> à tout ce qui empêcherait votre ID.4 de rayonner."
          headerBorder={true}
          caption="<p>Votre VUS 100 % électrique peut avoir une allure aussi propre que l’énergie à laquelle il fonctionne. Mais l’histoire ne s’arrête pas là, puisque cette housse de véhicule fait plus que simplement repousser les éléments.</p>"
          captionBorder={true}
          cta={true}
          ctaText="DÉCOUVREZ CE QU’ELLE FAIT DE PLUS"
          />
          </Slider>
          </div>
        );
      }else{
        return (
          <div className={darkClass}>
            <div className="box"></div>
            <div className="slideChangeContainer">
              <div className="slideChange slide1"></div>
              <div className="slideChange slide2"></div>
              <div className="slideChange slide3"></div>
              <div className="slideChange slide4"></div>
              <div className="slideChange slide5"></div>
              <div className="slideChange slide6"></div>
            </div>
            {carAnimation}
            <Slider {...settings} ref={slider => this.slider = slider && slider['innerSlider']}>
              
              <SliderSlide
              header="La plupart des<br/>housses de véhicule<br/>repoussent les<br/>éléments."
              headerBorder={false}
              animatedCaptionText="<p>La housse de véhicule la plus durable</p>"
              captionBorder={false}
              animatedBackground={true}
              cta={false}
              backgroundImg="/carcover/images/background/light-sequence/frame_01.jpg"
              />
              <SliderSlide
              
              header="Celle-ci<br/>les absorbe."
              headerBorder={false}
              animatedCaptionText="<p>La housse de véhicule la plus durable</p>"
              captionBorder={false}
              animatedBackground={true}
              cta={false}
              backgroundImg="/carcover/images/background/light-sequence/frame_20.jpg"
              />
              <SliderSlide
              header="Depuis qu’on l’a conçu, l’ID.4 "
              animatedHeaderText="ne cesse de nous émerveiller"
              headerBorder={true}
              caption="<p>On a enfin réussi. Notre premier VUS 100 % électrique pour un avenir entièrement électrique. Mais quand on passe des années à concevoir un véhicule dans le cadre de notre mission « Soyons le virage », c’est impossible de ne pas se mettre au défi pour voir si on pourrait en faire plus.</p><p>On s’est donc posé la question des milliers de fois, jusqu’à ce qu’on se demande : Et si l’ID.4 pouvait faire avancer la durabilité, même quand il était stationné ?</p>"
              
              captionBorder={true}
              cta={false}
              />
              
              <SliderSlide
              header="Notre solution : <br/>"
              animatedHeaderText="une housse de véhicule"
              headerBorder={true}
              caption="<p>Plus précisément, une housse de véhicule qui protégerait votre ID.4 de son environnement, mais qui absorberait aussi des éléments polluants. L’idée était simple. Enfin, assez simple. Parce qu’il fallait quand même inventer une housse de véhicule antipollution.</p>"
              
              captionBorder={true}
              cta={false}
              />

              <SliderSlide
              header="Alors comment on l’a créée<span class='fakeSpace--h1'>?</span>"
              
              headerBorder={true}
              caption="<p>On a appliqué un revêtement photocatalytique spécial sur sa couverture. Ce qui veut dire qu’elle est activée par la lumière du jour. Une fois activée, elle commence à absorber toutes sortes de composés indésirables dans l’air, </p><p>comme l’acétaldéhyde, le formaldéhyde et l’oxyde nitreux, et ce, pendant toute sa durée de vie utile. C’est quand même novateur pour un morceau de tissu.</p>"
              
              captionBorder={true}
              cta={false}
              />
              <SliderSlide
              header="Maintenant, dites bonjour à "
              animatedHeaderText="votre nouvel accessoire d’auto préféré."
              headerBorder={true}
              caption="<p>Après tout, la housse de véhicule a été conçue pour que votre ID.4 sans émission contribue à un avenir vert même quand il ne roule pas. N’enlevez pas les résidus crayeux, car ça veut dire que la housse fait son travail.</p><p>Et l’histoire ne s’arrête pas là, puisque cette housse de véhicule fait plus que simplement absorber les éléments.</p>"
              captionBorder={true}
              cta={true}
              ctaText="DÉCOUVREZ CE QU’ELLE FAIT DE PLUS"
              />
            </Slider>
            
          </div>
        );
      }
    }else{ 
      if(darkClass == "darkSlider"){
        return(
          <div className={darkClass}>
            <div className="box"></div>
            <div className="slideChangeContainer">
              <div className="slideChange slide1"></div>
              <div className="slideChange slide2"></div>
              <div className="slideChange slide3"></div>
              <div className="slideChange slide4"></div>
              <div className="slideChange slide5"></div>
              <div className="slideChange slide6"></div>
            </div>
          {carAnimation}
          <Slider {...settings} ref={slider => this.slider = slider && slider['innerSlider']}>
          
          <SliderSlide
          header="Most<br/>car covers<br/>repel the<br/>elements."
          headerBorder={false}
          animatedCaptionText="<p>The cleaner car cover</p>"
          captionBorder={false}
          animatedBackground={true}
          cta={false}
          backgroundImg="/carcover/images/background/dark-sequence/frame_01.jpg"
          />
          <SliderSlide
          header="This one is<br/>no exception."
          headerBorder={false}
          animatedCaptionText="<p>The cleaner car cover</p>"
          captionBorder={false}
          animatedBackground={true}
          cta={false}
          backgroundImg="/carcover/images/background/dark-sequence/frame_20.jpg"
          />
          <SliderSlide
          header="When we finished building the ID.4, "
          animatedHeaderText="we couldn’t help but stare."
          headerBorder={true}
          caption="<p>The sophisticated lines. The distinctive, striking silhouette. And, of course, that fresh-off-the-line sparkle. We knew we had to do everything in our power to keep our all-electric SUV looking all shiny and new.</p><p>So, after many years of hard work, we got right back to it, designing the perfect companion for the ID.4. It’s tried. It’s true. And it’s exactly what we needed.</p>"
          
          captionBorder={true}
          cta={false}
          />
          
          <SliderSlide
          header="You guessed it.<br/>"
          animatedHeaderText="A car cover."
          headerBorder={true}
          caption="<p>One that protects your ID.4 in all the ways you’d expect. After all, sometimes you need to rely on a classic to safeguard the future. Funny that.</p>"
          
          captionBorder={true}
          cta={false}
          />

          <SliderSlide
          header="So how does it work?"
          headerBorder={true}
          caption="<p>Simple. We designed your car cover with a protective lining that repels all manner of things that could besmirch your ID.4. Dirt and dust on your freshly cleaned car? Nope. Falling leaves finding their way under your windshield wipers?</p><p>Not on our watch. Bird droppings making a godawful mess? Wouldn’t dream of it. Not bad for a piece of fabric. We sure thought&nbsp;so.</p>"
          
          captionBorder={true}
          cta={false}
          />
          <SliderSlide
          header="Now say <span class='animatedHeader' style='animation-delay:1s'>goodbye</span> to anything that might soil the shine of your ID.4."
          headerBorder={true}
          caption="<p>Because finally, your all-electric SUV can look just as clean as the energy it runs on. But here’s the thing – there’s actually more to this story. That’s right, this car cover doesn’t just&nbsp;repel.</p>"
          captionBorder={true}
          cta={true}
          ctaText="SEE WHAT ELSE IT DOES"
          />
          </Slider>
          </div>
        );
      }else{
        return (
          <div className={darkClass}>
            <div className="box"></div>
            <div className="slideChangeContainer">
              <div className="slideChange slide1"></div>
              <div className="slideChange slide2"></div>
              <div className="slideChange slide3"></div>
              <div className="slideChange slide4"></div>
              <div className="slideChange slide5"></div>
              <div className="slideChange slide6"></div>
            </div>
            {carAnimation}
            <Slider {...settings} ref={slider => this.slider = slider && slider['innerSlider']}>
              
              <SliderSlide
              header="Most<br/>car covers<br/>repel the<br/>elements."
              headerBorder={false}
              animatedCaptionText="<p>The cleaner car cover</p>"
              captionBorder={false}
              animatedBackground={true}
              cta={false}
              backgroundImg="/carcover/images/background/light-sequence/frame_01.jpg"
              />
              <SliderSlide
              header="This one<br/>absorbs<br/>them."
              headerBorder={false}
              animatedCaptionText="<p>The cleaner car cover</p>"
              captionBorder={false}
              animatedBackground={true}
              cta={false}
              backgroundImg="/carcover/images/background/light-sequence/frame_20.jpg"
              />
              <SliderSlide
              header="When we finished building the ID.4, "
              animatedHeaderText="we couldn't help but marvel at it."
              headerBorder={true}
              caption="<p>We’d finally done it. Our first all-electric SUV for an all-electric future. But when you spend years engineering an emission-free vehicle while on a journey to Be the Change, it’s impossible not to wonder: what if we could make it do even more?</p><p>As we asked ourselves this impossible question for the umpteenth time, it suddenly occurred to us. What if the ID.4 could drive sustainability, even when parked?</p>"
              
              captionBorder={true}
              cta={false}
              />
              
              <SliderSlide
              header="Hence,<br/>"
              animatedHeaderText="a car cover."
              headerBorder={true}
              caption="<p>One that protects your ID.4 from the environment, but not just in the ways you’d expect. Because ours would absorb pollutants. The idea was simple. Well, simpleish. We are talking about a pollution-eating car cover after all.</p>"
              
              captionBorder={true}
              cta={false}
              />

              <SliderSlide
              header="So how’d we do it?"
              
              headerBorder={true}
              caption="<p>We applied a special photocatalyst coating to your cover. That means it’s activated by daylight. And once activated, it starts eating all sorts of unwelcome airborne compounds for the lifespan of the coating.</p><p>Acetaldehyde? Absorbed. Formaldehyde? Sucked right up. Nitrous oxide? Extracted right from the air. Pretty novel for a piece of fabric. We sure thought so.</p>"
              
              captionBorder={true}
              cta={false}
              />
              <SliderSlide
              header="Now say hello to what we hope becomes "
              animatedHeaderText="your new favourite car accessory."
              headerBorder={true}
              caption="<p>After all, it's engineered so your emission-free ID.4 can do its thing, even when it's not doing its thing. And don’t wash off any chalky residue – that’s the coating hard at work. But this isn't the entire story. This car cover does much more than just&nbsp;absorb.</p>"
              
              captionBorder={true}
              cta={true}
              ctaText="SEE WHAT ELSE IT DOES"
              />
            </Slider>
            
          </div>
        );
      }
  }
  }
}